<!--实时库存-->
<template>
    <div class="stock">
        <div class="select-wrapper">
            <van-dropdown-menu>
                <van-dropdown-item
                    v-model="currentStationId"
                    :options="stationList"
                ></van-dropdown-item>
            </van-dropdown-menu>
        </div>
        <div class="material-wrapper">
            <van-swipe
                class="my-swipe"
                :loop="false"
                indicator-color="white"
            >
                <van-swipe-item v-for="(items,index) in monitorList" :key="'swipe'+index">
                    <ul>
                        <li v-for="(item,mindex) in items" :key="'item'+index+mindex">
                            <div class="top-name">
                                {{ item.stock_no }}
                            </div>
                            <div :class="['val-box',item.bgClass]">
                                <div class="percentage">
                                    <div class="percentage-val" :style="{height: item.percentage+'%',background:item.color}"></div>
                                </div>
                                <span class="val-num">{{ item.volume_theory }}</span>
                                <span class="warn-num">{{ item.volume_warn }} -</span>
                            </div>
                            <div class="bottom-name" :title="item.stock_name">
                                <i class="brage" :style="{background:item.color}"></i>
                                {{ item.stock_name }}
                            </div>
                        </li>
                    </ul>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="split-line"></div>
        <div class="productionLine" v-if="lineList.length>0">
            <van-tabs
                v-model="selectLine"
                title-active-color="#E40002"
            >
                <template v-for="(item, index) in lineList">
                    <van-tab
                        :key="index"
                        :title="item.line_name"
                        :name="item.line_no"
                    ></van-tab>
                </template>
            </van-tabs>
        </div>
        <div class="admixture">
            <div class="my-swipe">
                <ul v-if="lineMonitorMap[selectLine]">
                    <li v-for="(item,index) in lineMonitorMap[selectLine].materials" :key="'mater'+index">
                        <div class="top-name">
                            {{ item.stock_no }}
                        </div>
                        <div class="val-box">
                            <div class="percentage">
                                <div class="percentage-val" :style="{height: item.percentage+'%',background:item.color}"></div>
                            </div>
                            <span class="val-num">{{ item.volume_theory }}</span>
                            <span class="warn-num">{{ item.volume_warn }} -</span>
                        </div>
                        <div class="bottom-name more-text">
                            <i class="brage" :style="{background:item.color}"></i>
                            <span>{{ item.stock_name }}</span>
                        </div>
                    </li>
                </ul>
                <ul class="ul2" v-if="lineMonitorMap[selectLine]">
                    <template v-for="(item,index) in lineMonitorMap[selectLine].admixtures">
                        <li :key="'admixtur'+index">
                            <div class="top-name">
                                {{ item.stock_no }}
                            </div>
                            <div class="val-box val-box2">
                                <div class="water-bg">
                                    <div class="water-val" :style="{height:item.percentage+'%'}">
                                        <span class="warn-num" :style="{bottom:item.warnPercentage+'%'}">{{ item.volume_warn }} -</span>
                                    </div>
                                    <div class="water-bottom"></div>
                                </div>
                                <span class="val-num">{{ item.volume_theory }}</span>
                            </div>
                            <div class="bottom-name">
                                <span>{{ item.stock_name }}</span>
                            </div>
                        </li>
                        <li :key="'admixtur'+index" v-if="index!=lineMonitorMap[selectLine].admixtures.length-1">
                            <div class="top-name"></div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    // 实时库存
    name: 'stock',
    components: {},
    props: {},
    data() {
        return {
            // 当前场站id
            currentStationId: '',
            // 场站列表
            stationList: [],

            // 生产线路
            lineList: [],
            // 选中的生产线 编号
            selectLine: '',
            // 虚拟料仓（砂、石） 二维数组
            monitorList: [],
            // 物理料仓数据
            lineMonitorMap: {},
        };
    },
    computed: {},
    watch: {
        // 场站变更
        currentStationId(val) {
            if (val) {
                this.getProductionLine();
            }
        },
    },
    created() {
        // 获取企业下所有场站
        this.getStationList();
    },
    mounted() { },
    destroyed() { },
    methods: {
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                this.stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.currentStationId = stationIds[0];
            }
        },

        // 获取生产线
        async getProductionLine() {
            const res = await this.$axios.get(`/interfaceApi/report/largescreen3/scx/${this.currentStationId}`);
            if (res.length > 0) {
                this.lineList = res;
                this.selectLine = this.lineList[0].line_no;
                this.getData();
            } else {
                this.lineList = [];
                this.selectLine = '';
            }
        },
        // source_name: ""
        // stock_code: "023-F3-01-XN-01-002"
        // stock_name: "石灰岩砂(中砂)"
        // stock_no: "机制砂华能"
        // team_id: ""
        // team_name: ""
        // type_dic_code: "203"
        // volume_max: 6000
        // volume_theory: -5635.95
        // volume_warn: 1500
        // 获取库存情况
        getData() {
            this.$toast.loading();
            const enterpriseTenantId = this.$takeTokenParameters('TenantId');
            this.$axios
                .get(`/interfaceApi/procurement/stock/monitor/${this.currentStationId}?tenant_id=${enterpriseTenantId}`)
                .then(res => {
                    if (res) {
                        const lineMonitorList = [];
                        const monitorList = [];
                        res.map(item => {
                            if (item.volume_theory <= item.volume_warn) {
                                item.color = '#FF5353';
                            } else if (item.volume_theory > item.volume_warn && item.volume_theory < item.volume_max / 2) {
                                item.color = '#F7B500';
                            } else {
                                item.color = '#6DD400';
                            }
                            if (item.volume_theory > 0) {
                                item.percentage = Number((item.volume_theory / item.volume_max * 100).toFixed(2));
                            } else {
                                item.percentage = 0;
                            }
                            if (item.volume_warn > 0) {
                                item.warnPercentage = Number((item.volume_warn / item.volume_max * 100).toFixed(2));
                            } else {
                                item.warnPercentage = 0;
                            }
                            if (['203', '204'].includes(item.type_dic_code) ) {
                                if (item.type_dic_code === '203') {
                                    item.bgClass = 'legend1';
                                } else if (item.type_dic_code === '204') {
                                    item.bgClass = 'legend2';
                                }
                                monitorList.push(item);
                            } else {
                                lineMonitorList.push(item);
                            }
                        });
                        // 每4个一组 做轮播
                        this.monitorList = [];
                        for (let i = 0; i < monitorList.length; i += 4) {
                            this.monitorList.push(monitorList.slice(i, i + 4));
                        }
                        this.formatLineMonitorData(lineMonitorList);
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                }).finally(() => {
                    this.$toast.clear();
                });
        },
        // 获取库存情况-物理料仓数据处理
        formatLineMonitorData(data) {
            const monitorMapping = {};
            data.forEach(item => {
                const team_ids = item.team_id.split(',');
                if (team_ids.length > 1) {
                    team_ids.forEach(teamId => {
                        if (monitorMapping[teamId]) {
                            monitorMapping[teamId].push(item);
                        } else {
                            monitorMapping[teamId] = [item];
                        }
                    });
                } else {
                    monitorMapping[item.team_id] = monitorMapping[item.team_id] || [];
                    monitorMapping[item.team_id].push(item);
                }
            });
            const resultMapping = {};
            this.lineList.forEach(line => {
                const list = monitorMapping[line.line_no] || [];
                resultMapping[line.line_no] = {
                    materials: [],
                    admixtures: [],
                };
                list.forEach(item => {
                    if (item.type_dic_code !== '208') {
                        resultMapping[line.line_no].materials.push(item);
                    } else {
                        resultMapping[line.line_no].admixtures.push(item);
                    }
                });
            });
            this.lineMonitorMap = resultMapping;
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="stylus">
@font-face
    font-family technology
    src url('../../../assets/fonts/font/technology.ttf')
.stock
    height 100%
    .split-line
        height: 15rpx;
        background: #F0F0F0;
    .select-wrapper
        position fixed
        top 3rpx
        right 20rpx
        z-index 2
        .van-dropdown-menu
            .van-dropdown-menu__bar
                height 35rpx;
                background-color transparent
                .van-dropdown-menu__title
                    color #fff
    .material-wrapper,.admixture
        padding 14rpx
        .my-swipe
            padding-bottom 20rpx
            min-height 155rpx
            ul
                display flex
                li
                    width 25%
                    height 126rpx
                    display flex
                    flex-direction column
                    justify-content space-between
                    align-items center
                    .top-name,.bottom-name
                        width 100%;
                        height 24rpx
                        line-height 24rpx
                        text-align center
                        font-size 12rpx;
                        color #333;
                        background #EEF3FD
                        border 1px solid #E2E7F1
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis
                    .bottom-name
                        width 90%;
                        position relative
                        white-space nowrap
                        text-overflow ellipsis
                        overflow hidden
                        font-size 12rpx
                        .brage
                            width 40rpx
                            height 40rpx
                            background #00A84B
                            transform rotate(45deg)
                            position absolute
                            left -28rpx;
                            top -28rpx
                    .val-box
                        width 60rpx
                        height 60rpx
                        background url("../../../assets/images/sales/stock02.png") center
                        background-size 100% 100%
                        position relative
                        &.legend2
                            background url("../../../assets/images/sales/stock03.png") center
                            background-size 100% 100%
                        .percentage
                            position absolute
                            left 3rpx
                            bottom 15rpx
                            width 5rpx
                            height 36rpx
                            background #192F52
                            border-radius 10rpx
                            overflow hidden
                            .percentage-val
                                width 3rpx
                                height 30%;
                                max-height 99%
                                border-radius 10rpx
                                background #6DD400
                                position absolute
                                left 0
                                right 0
                                bottom 1px
                                margin auto
                        .val-num
                            position absolute
                            left 0
                            top 3rpx
                            width 100%
                            text-align center
                            font-family: Technology-Regular, Technology;
                            font-size 16rpx
                            color #fff;
                            text-shadow: 2rpx 2rpx 4rpx #000000
                        .warn-num
                            position absolute
                            right 0
                            bottom 10rpx;
                            width 100%
                            text-align: right;
                            font-size 10rpx
                            color #FE0000
                            padding-right 14rpx

            .van-swipe__indicators
                .van-swipe__indicator
                    width 15rpx;
                    height 3rpx
                    background-color #F0F0F0!important
                    border-radius: 3rpx;
                .van-swipe__indicator--active
                    background-color #E40002 !important
    .admixture
        .my-swipe
            overflow-x auto
            ul
                margin-top 15rpx;

                li
                    width 75rpx
                    height 167rpx
                    flex-shrink 0
                    .more-text
                        height 40rpx
                        line-height 15rpx
                        display flex
                        justify-content center
                        align-items center
                        span
                            white-space normal
                            overflow: hidden;
                            display: -webkit-box;
                            text-overflow: ellipsis;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                    .val-box
                        width 50rpx
                        height 80rpx
                        background url("../../../assets/images/sales/stock04.png") center
                        background-size 100% 100%
                        .percentage
                            height 56rpx
                            bottom 19rpx
                            left 5rpx
                            background #586270
                        .warn-num
                            bottom 19rpx
                            padding-right 0
                        .water-bg
                            width 100%;
                            height 100%;
                            background #D9DBE5
                            position relative
                            .water-val
                                position absolute
                                bottom 0
                                width 100%
                                height 30%
                                background #0BA360
                            .water-bottom
                                position absolute
                                bottom -17rpx
                                width 0
                                height 0
                                border-style solid
                                border-width 17rpx 25rpx 0
                                border-color #0BA360 #fff #fff
            .ul2
                li
                    height 130rpx;
                    .val-box
                        height 50rpx
                        margin-bottom 15rpx
</style>
